jQuery(document).ready(function ($) {
  $(document).on("click", ".loadmore", function (e) {
    let $this = $(this);
    e.preventDefault();

    var initialText = $this.text();
    $this.attr("disabled", true);

    var str = "";
    if (s.length > 0) {
      str += "&s=" + s;
    }
    if (starts_with.length > 0) {
      str += "&starts_with=" + starts_with;
    }
    if (post_per_page > 0) {
      str += "&post_per_page=" + post_per_page;
    }
    if (author_id > 0) {
      str += "&author_id=" + author_id;
    }
    if (post_type.length > 0) {
      str += "&post_type=" + post_type;
    }

    if (tag_name.length > 0) {
      str += "&tag_name=" + tag_name;
    }

    if (category_name.length > 0) {
      str += "&category_name=" + category_name;
    }
    
    pageNumber++;

    str +=
      "&pageNumber=" +
      pageNumber +
      "&maxPages=" +
      maxPages +
      "&is_list=" +
      is_list +
      "&action=more_post_ajax";

    $.ajax({
      type: "POST",
      dataType: "html",
      beforeSend: function (xhr) {
        $(this).text("تحميل...");
      },
      url: loadmore_params.ajaxurl,
      data: str,
      success: function (data) {
        var $data = $(data);
        if ($data.length) {
          $(".loadmore_grid").append($data);
          $this.attr("disabled", false);
          $this.text(initialText);
          if (maxPages == pageNumber) {
            $this.remove();
          }
        } else {
          $this.remove();
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {},
    });
    return false;
  });
});
